import { render, staticRenderFns } from "./BranchDcRoutingOverride.vue?vue&type=template&id=ccff79ae&scoped=true"
import script from "./BranchDcRoutingOverride.vue?vue&type=script&lang=js"
export * from "./BranchDcRoutingOverride.vue?vue&type=script&lang=js"
import style0 from "./BranchDcRoutingOverride.vue?vue&type=style&index=0&id=ccff79ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccff79ae",
  null
  
)

export default component.exports